import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { PropAsset } from '../../../../usePropValues';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import ContentCarousel from './components/Carousel';
import { desktopAspectX, desktopAspectY } from '../../../CardsConfig';

type ValuePropCardProps = {
  data: PropAsset & { type: 'prop' };
};

const VALUE_PROP_STYLES = {
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  width: '100%',
  height: '100%',
  border: '1px solid hsl(0, 0%, 90%)',
} as const;

export const ValuePropCard = (props: ValuePropCardProps) => {
  const isMobile = useIsMobileScreen();
  const { data } = props;
  const { row, column, columns = 1 } = data;
  const contentList = data.contentList.filter(asset => asset.responsiveTarget === (isMobile ? 'mobile' : 'desktop'));

  // Calculate grid-area CSS property
  // Locates prop within the grid.
  const gridAreaValue = `${row + 1} / ${column + 1} / ${row + 1} / span ${columns}`;
  // Aspect ratio for mobile / desktop factoring in width in columns.
  const aspectRatio = isMobile ? `${1 * columns} / 2` : `${Number(desktopAspectX) * columns} / ${desktopAspectY}`;

  if (!contentList.length) return null;

  return (
    <Flex
      gridArea={gridAreaValue}
      aspectRatio={aspectRatio}
      background="hsla(45, 12%, 93%, 1)"
      width="100%"
      height="100%"
    >
      <Box
        height="100%"
        width="100%"
        overflow="hidden"
        position="relative"
        style={VALUE_PROP_STYLES}
      >
        <ContentCarousel
          autoRotatePeriodMs={7500}
          content={contentList}
          {...data}
        />
      </Box>
    </Flex>
  );
};
